import AppContainer from "components/AppContainer";
import Layout from "@edaz/edazkit/Layout";
import LoaderOverlay from "@edaz/edazkit/LoaderOverlay";
import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import { registerView, View } from "@frui.ts/views";
import { observer, Observer } from "mobx-react-lite";
import { appVersion } from "../config";
import { isProduction } from "../utils/featureToogle";
import RootViewModel from "../viewModels/rootViewModel";
import AppHeader from "./appHeader";

const rootView: ViewComponent<RootViewModel> = observer(({ vm }) => {
  return (
    <LoaderOverlay loading={vm.loading}>
      <AppHeader vm={vm} />
      <Layout>
        <AppContainer>
          <Observer>{() => <View vm={vm.alertsViewModel} />}</Observer>
          <Observer>{() => <View vm={vm.activeChild} />}</Observer>
          {!isProduction() && (
            <div className="py-2">
              {vm.translateGeneral("appVersion")} {appVersion}
            </div>
          )}
        </AppContainer>
      </Layout>
      {vm.logoutUrl && (
        <iframe title="Logout" src={vm.logoutUrl} onLoad={vm.onLogoutComplete} width={1} height={1} className="d-none" />
      )}
    </LoaderOverlay>
  );
});

registerView(rootView, RootViewModel);
